import {
  CREATE_CTC_CREDENTIAL,
  UPDATE_CTC_CREDENTIAL,
  GET_CTC_CREDENTIAL,
  GET_CTC_CREDENTIAL_BY_ID,
} from '../actions/CtcCredentials.action';

const initialState = {
  createCtcCredential: '',
  updateCtcCredential: '',
  getCtcCredential: '',
  getCtcCredentialById: '',
};

const CtcCredentialsReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_CTC_CREDENTIAL:
      return { ...state, createCtcCredential: action.payload };
    case UPDATE_CTC_CREDENTIAL:
      return { ...state, updateCtcCredential: action.payload };
    case GET_CTC_CREDENTIAL:
      return { ...state, getCtcCredential: action.payload };
    case GET_CTC_CREDENTIAL_BY_ID:
      return { ...state, getCtcCredentialById: action.payload };
    default:
      return { ...state };
  }
};

export default CtcCredentialsReducer;
